export default __webpack_public_path__ + "static/media/notes.804ef235.png";